import { useUserContext } from 'features/user/context';

export const useFeatureFlag = (featureFlagKey: string) => {
  const { user } = useUserContext();
  const isFeatureEnabled = user.featureFlags?.[featureFlagKey] ?? false;

  return isFeatureEnabled;
};
